// The patient closed the crisis resources for a day. A per-browser convenience:
// a new flagged message shows them again, and a lost value only shows them once
// more, which is the safe side.

const key = (pid, date) => `journal.crisisDismissed.${pid}.${date}`;

export function isCrisisDismissed(pid, date) {
  try {
    return window.localStorage.getItem(key(pid, date)) === "1";
  } catch {
    return false;
  }
}

export function setCrisisDismissed(pid, date, dismissed) {
  try {
    if (dismissed) window.localStorage.setItem(key(pid, date), "1");
    else window.localStorage.removeItem(key(pid, date));
  } catch {
    // Storage unavailable: the resources stay visible.
  }
}
